import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=74553b86&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74553b86')) {
      api.createRecord('74553b86', component.options)
    } else {
      api.reload('74553b86', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=74553b86&", function () {
      api.rerender('74553b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UBWIJf46EtDs/JS/comp/ImgFallback.vue"
export default component.exports